import { Hidden }                   from "@material-ui/core";
import * as React                   from "react";
import { FC }                       from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card }                     from "semantic-ui-react";
import Account                      from "../../../../domain/account/Account";
import AccountRoleType              from "../../../../domain/account/AccountRoleType";
import { ResKaState }               from "../../../../index";
import RouterDispatcher             from "../../../../infrastructure/redux/router/RouterDispatcher";

const OfficeSettingButton: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  switch (account.role.value) {
    default:
      return null;
    case AccountRoleType.CORPORATION:
    case AccountRoleType.OFFICE:
      return (
        <>
          <Hidden smDown={ true }>
            <Card onClick={ () => routerDispatcher.office() }>
              <Card.Content>
                <Card.Header>事業所情報を編集する</Card.Header>
                <Card.Description>
                  事業所の名称変更や移転など、登録時の設定から変更することができます。
                </Card.Description>
              </Card.Content>
            </Card>
          </Hidden>

          <Hidden mdUp={ true }>
            <Card onClick={ () => routerDispatcher.office() }>
              <Card.Content>
                <Card.Header>事業所情報を編集する</Card.Header>
              </Card.Content>
            </Card>
          </Hidden>
        </>
      );
  }
};

export default OfficeSettingButton;
